/**
 * This class is used to mimic the ColumnNameHelper class in the backend.
 * It is used to normalize column names for SQL queries.
 * It is used to convert frontend keys to SQL column names.
 */

/** This is a Postgres limit for the max length of a column name. */
const MAX_COLUMN_NAME_LENGTH = 63;

export const normalizeFrontendKey = (key: string) => {
    const dotIndex = key.indexOf('.');
    if (dotIndex !== -1) {
        key = key.substring(dotIndex + 1);
    }

    key = key.toLowerCase();

    if (!key.startsWith('_') && !/^[a-z]/.test(key[0])) {
        key = `_${key}`;
    }

    key = key.replace(/[^a-z0-9_]/g, '');

    if (key.length > MAX_COLUMN_NAME_LENGTH) {
        key = key.substring(0, MAX_COLUMN_NAME_LENGTH);
    }

    return key;
};
